export default __webpack_public_path__ + "static/sprite-plugins-2eda34d18587ade0bf402b5bfc45e0d4.svg";